// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2ah76","content":"Consent_content__3gUTP","footer":"Consent_footer__1wPQv"};